import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const HOSPITAL_DISCHARGE_FU_URL = `${API_BASE_URL}/api/advancedmd/hospitaldischargefollowup`;

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
});

/**
 * Obtiene las notas "_Hospital Discharge Follow Up" de un paciente.
 */
export async function getHospitalDischargeFollowUpNotes(patientId) {
  try {
    const url = `${HOSPITAL_DISCHARGE_FU_URL}/${encodeURIComponent(patientId)}`;
    const res = await axios.get(url, { headers: authHeader() });
    return res.data;
  } catch (err) {
    console.error("Error getHospitalDischargeFollowUpNotes:", err);
    throw err;
  }
}